import type { BuildingLayerItem } from "features/dt-basic-setup/single-building/model/types";

import { createId } from "utils/general";

import { CUSTOM_KEY } from "../constants";

export function migrateLayers(raw: unknown): BuildingLayerItem[] {
  if (!Array.isArray(raw) || raw.length === 0) {
    return [];
  }

  const mapped = raw.map((layer: any, _index: number) => {
    if (!layer || typeof layer !== "object") {
      return undefined;
    }
    const preset = layer.preset ?? CUSTOM_KEY;
    const subLayersRaw = Array.isArray(layer.subLayers) ? layer.subLayers : [];
    const subLayers = subLayersRaw.map((sl: any) => ({
      ...sl,
      id: sl.id ?? createId(),
      objects:
        sl.objects?.map((o: any) => ({
          ...o,
          id: o.id ?? createId(),
          points: o.points ?? [],
        })) ?? [],
    }));
    return {
      ...layer,
      id: layer.id ?? createId(),
      name: layer.name ?? "",
      preset,
      subLayers,
      visible: layer.visible !== false,
    } as BuildingLayerItem;
  });
  return mapped.filter((l): l is BuildingLayerItem => l != null);
}
